import {
  iCall,
  iPathObj,
} from '../../shared/communication-module/types'
import { iGetAuthData } from '../../shared/oauth2-auth-code-flow-pkce/get-auth-data'
import { iLogout } from '../../shared/oauth2-auth-code-flow-pkce/logout'
import { Irefresh } from '../../shared/oauth2-auth-code-flow-pkce/refresh'
import { ArchitectureProvider, useArq } from '../react-utils'
import { IsAuthenticated } from '../react-utils/is-authenticated/IsAuthenticated'
import { IsNotAuthenticated } from '../react-utils/is-not-authenticated/IsNotAuthenticated'
import arq, { iMediatorConfig } from './mediator'
import { iLang } from './types'

// aunque estas variables se inician a undefined serán asignadas durante la
// inicialización de la arquitectura
let env: string

let auth = {} as iAuthFacade

const lang = {} as iLang
let call: iCall
let api: iPathObj

export type iFacadeConfig = iMediatorConfig

export interface iAuthFacade {
  getData: iGetAuthData
  logout: iLogout
  refresh: Irefresh
}

export interface iFacadeApi {
  lang: iLang
  call: iCall
  api: iPathObj
  auth: iAuthFacade
  env: string
}

const init = async (
  initConfig: iFacadeConfig,
): Promise<iFacadeApi> => {
  const apiArq = await arq(initConfig)

  lang.currentLanguage = apiArq.i18n.language
  lang.currentLangCode = apiArq.i18n.langCode
  lang.changeLanguage = apiArq.i18n.changeLanguage
  lang.availableLanguages = initConfig.i18nConfig.availableLanguages

  call = apiArq.call
  api = apiArq.api
  auth = {
    getData: apiArq.auth.getData,
    logout: apiArq.auth.logout,
    refresh: apiArq.auth.refresh,
  }

  env = apiArq.env

  return {
    api,
    auth,
    call,
    env,
    lang: {
      availableLanguages: lang.availableLanguages,
      currentLanguage: lang.currentLanguage,
      currentLangCode: lang.currentLangCode,
      changeLanguage: lang.changeLanguage,
    },
  }
}

export default init

export * from './types'
export {
  api,
  auth,
  call,
  env,
  lang,
  ArchitectureProvider,
  IsAuthenticated,
  IsNotAuthenticated,
  useArq,
}
